import { render, staticRenderFns } from "./MenuSyncModal.vue?vue&type=template&id=30d4ad6f"
import script from "./MenuSyncModal.vue?vue&type=script&lang=js"
export * from "./MenuSyncModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports